export const GET_WALLET = "GET_WALLET";